import heroImg from '../assets/img/hero.jpg'
import { useSiteSettings } from '../contexts/SiteSettingsContext'

export function Hero() {
    // Read hero text from shared context — no extra API call
    const settings = useSiteSettings()
    const heroTitle = settings?.heroTitle || 'מה שלא עושה הטבע זליג עושה בשיפוצים והצבע'
    const heroSubtitle = settings?.heroSubtitle || 'שמי אייל זליג, אני קבלן שיפוצים וגמר המתמחה בשיפוץ פנים משנת 2014. אני בעל ניסיון רב בתחום, ואני מעניק שירות אישי, מקצועי וחדשני. אני בטוח שאוכל לספק לכם את השירות הטוב ביותר!'

    return <section className='hero main-layout full' id='hero'>
        <div>
            <div className='info-container flex justify-between column align-center'>
                <div className="header-conteiner">
                    <h1>
                        {heroTitle.includes('זליג') ? (
                            <>
                                {heroTitle.split('זליג')[0]}
                                <span>זליג</span>
                                {heroTitle.split('זליג').slice(1).join('זליג')}
                            </>
                        ) : (
                            heroTitle
                        )}
                    </h1>
                </div>
                <div className='paragraph-container'>
                    <hr />
                    <p>{heroSubtitle}</p>
                    <div className='profile-img-container'>
                        <img src={heroImg} alt="אייל זליג" />
                    </div>
                </div>
            </div>
        </div>
    </section>
}